<template>
  <header ref="headerComponent">
    <a href="/main" class="header__container" ref="headerComponent">
      <img v-if="returnLogo" class="header__logo--one" :src="`/Images/${returnLogo}`" />
      <img v-if="false" class="header__logo--one" src="/Images/logo-dealer-demo.webp" />
      <img v-if="false" class="header__logo--one" src="/Images/duda.webp" />
      <img v-if="false" class="header__logo--one" src="/Images/ics.webp" />
      <img v-if="false" class="header__logo--one" src="/Images/nobile.webp" />
      <!-- <img v-if="returnLogoProgram === 'program-logo-demo.webp'" class="header__logo--two" :src="require(`/Images/${returnLogoProgram}`)" />
      <img v-if="false" class="header__logo--two" src="/Images/program-logo-demo.webp" />
      <img v-if="returnLogoProgram === 'nobile-program.webp'" class="header__logo--two" :src="require(`/Images/${returnLogoProgram}`)" />
      <img v-if="false" class="header__logo--two" src="/Images/nobile-program.webp" />
      <img v-if="returnLogoProgram === ''" class="header__logo--two" src="/Images/benz_logo.webp" />
      <img v-if="returnLogoProgram === 'twojaoferta-duda.webp' && mainOffer[0] && mainOffer[0].typeId === 2" class="header__logo--two" src="/Images/benz_logo.webp" /> -->
      <img class="header__logo--two" src="/Images/logo_ww_yll.png" />
    </a>
  </header>
</template>

<script>
import { useStore } from "../../store";

export default {
  computed: {
    returnLogo() {
      return useStore().getAssets;
    },
    returnLogoProgram() {
      return useStore().getLogoProgram;
    },
    mainOffer() {
      return useStore().getMainOffer;
    },
  },
};

//VUE_APP_LOGO_PROGRAM='twojaoferta-duda.webp'
</script>
